import { FRONTEND, FRONTENDCSS } from '../constants';

export const FRONTENDSKILLS = {
    category: FRONTEND,
    skills: [
        {
            category: FRONTEND,
            skill: 'React.js',
            level: 9,
        },
        {
            category: FRONTEND,
            skill: 'UI Styling',
            level: 9,
        },
        {
            category: FRONTEND,
            skill: 'TypeScript',
            level: 8,
        },
        {
            category: FRONTENDCSS,
            skill: 'CSS3',
            level: 8,
        },
        {
            category: FRONTEND,
            skill: 'Redux Tookit',
            level: 7,
        },

        {
            category: FRONTENDCSS,
            skill: 'Material UI',
            level: 7,
        },
        {
            category: FRONTEND,
            skill: 'Jest / React Testing Library',
            level: 5,
        },

        {
            category: FRONTENDCSS,
            skill: 'Styled Components',
            level: 6,
        },
        {
            category: FRONTEND,
            skill: 'React Native',
            level: 5,
        },
        {
            category: FRONTENDCSS,
            skill: 'Vue.js',
            level: 4,
        },
    ],
};
